import { Fragment, useEffect, useState } from 'react';
import { IGlobalHistory, IShipmentData, SHIPMENT_STATUS_ID } from '../../../../../../../types/orders';
import { formatShortDateAndHour } from '../../../../../../../utils/formatDatesAndHours';
import ShipmentTrackingData from '../ShipmentTrackingData/ShipmentTrackingData';
import './TrackingAndDatesSection.scss';

interface IDateProperties {
  nameDate: string;
  valueDate?: string | null;
  key?: string;
}

const TrackingAndDatesSection = ({
  shipmentData,
  countryTimeZone,
  setShowProcessModal,
  setIsEditedProcessModal
}: {
  shipmentData: IShipmentData;
  countryTimeZone?: number;
  setShowProcessModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEditedProcessModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [datesList, setDatesList] = useState<IDateProperties[]>([]);
  const showEstimatedInWarehouse = SHIPMENT_STATUS_ID.CONFIRMED < shipmentData?.statusId;
  const { shipmentStatusDates, trackingInfo, globalHistory, warehouseTemporaryStorage } = shipmentData;
  const { pending, confirmed, deliveryProcess, cancelled } = shipmentStatusDates;
  const { currentEstimatedDeliverDate, deliveryDate, trackingLink, oldEstimatedDeliveryDates } = trackingInfo;

  const { estimatedEntryDate } = warehouseTemporaryStorage || {};
  const wharehouseTemporaryStorageDate =
    estimatedEntryDate && showEstimatedInWarehouse ? estimatedEntryDate : undefined;

  const shipmentHasTrackingInfo =
    currentEstimatedDeliverDate || deliveryDate || trackingLink || !!oldEstimatedDeliveryDates?.length;

  const generateCopyItem = (historyType: 'edition' | 'report', platform?: 'NODI' | 'SOGA') => {
    const isReport = historyType === 'report';
    const nodiEdition = historyType === 'edition' && platform === 'NODI';
    const sogaEdition = historyType === 'edition' && platform === 'SOGA';
    if (isReport) return 'Correo enviado - error en información:';
    if (nodiEdition) return 'Información del envío actualizado desde Nodi';
    if (sogaEdition) return 'Información del envío actualizado desde Soga';
  };

  const globalHistoryFormat = (dates: IGlobalHistory[]) => {
    const formatDates: IDateProperties[] = [];
    for (const date of dates) {
      if (date.createdAt) {
        const newDate = {
          nameDate: generateCopyItem(date?.typeLog, date?.platform) || '',
          valueDate: date?.createdAt
        };
        if (newDate?.nameDate && newDate?.valueDate) {
          formatDates.push(newDate);
        }
      }
    }
    return formatDates;
  };

  const unifyDates = () => {
    const trakingDates: IDateProperties[] = [
      { nameDate: 'Cancelado', valueDate: cancelled },
      { nameDate: 'Entregado', valueDate: deliveryDate },
      {
        nameDate: 'Proceso de entrega',
        valueDate: shipmentHasTrackingInfo && deliveryProcess ? deliveryProcess : undefined,
        key: 'deliveryProcess'
      },
      { nameDate: 'En bodega', valueDate: wharehouseTemporaryStorageDate },
      { nameDate: 'Confirmado', valueDate: confirmed },
      { nameDate: 'Pendiente de confirmación', valueDate: pending }
    ];
    const filterTrakingDates: IDateProperties[] = trakingDates.filter(trakingDate => !!trakingDate?.valueDate);
    const historyDates = globalHistoryFormat(globalHistory || []);
    const unionOfLists: IDateProperties[] = [...historyDates, ...filterTrakingDates];
    const orderList = unionOfLists.sort(
      (a: IDateProperties, b: IDateProperties) =>
        new Date(b?.valueDate || '').getTime() - new Date(a?.valueDate || '').getTime()
    );
    setDatesList([...orderList]);
  };

  useEffect(() => {
    unifyDates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipmentData]);

  return (
    <div className="trackingAndDatesSection">
      {/* This is the date that the ops user selected in the date picker as the delivery date for a shipment, not the actual date that the shipment was moved to the "Entregado" status */}
      {datesList &&
        datesList.length > 0 &&
        datesList.map((dateInfo, index) => {
          return (
            <Fragment key={`order-items-${dateInfo?.nameDate}-${index}`}>
              <div
                className={`${
                  dateInfo.key === 'deliveryProcess' && !!dateInfo.valueDate ? 'deliveryProcessBlock' : ''
                }`}
              >
                {dateInfo?.valueDate && (
                  <div className={`logisticsDate ${index === 0 ? 'active' : ''}`}>
                    {dateInfo.nameDate} : {formatShortDateAndHour(dateInfo?.valueDate || '')?.textWithTimezone}
                  </div>
                )}
                {dateInfo?.key === 'deliveryProcess' && (
                  <ShipmentTrackingData
                    shipmentData={shipmentData}
                    countryTimeZone={countryTimeZone}
                    setShowProcessModal={setShowProcessModal}
                    setIsEditedProcessModal={setIsEditedProcessModal}
                  />
                )}
              </div>
            </Fragment>
          );
        })}
    </div>
  );
};

export default TrackingAndDatesSection;
